export const BlackListMessages = [
    "Freelancer not found"
]